import styles from './RelatedTours.module.scss';
import { useNavigate } from 'react-router-dom';
import TourCard from '../../components/TourCard/TourCard';

const RelatedTours = ({ relatedTours }) => {
  const navigate = useNavigate();
  if (!relatedTours || relatedTours.length === 0) {
    return null;
  }



  return (
    <div className={styles.root}>
      <h3 className={styles.title}>こちらもおすすめ</h3>
      <TourCard items={relatedTours} />
      {/* <div className={styles.cardContainer}>
        {relatedTours.map((item, index) => (
          <div
            key={index}
            className={styles.card}
            onClick={() => navigate(`/tours/${item.rezdy_id}`)}
          >
            <div className={styles.imageWrapper}>
              <img
                src={item.image1}
                alt={`${item.title} 画像`}
                className={styles.image}
              />
            </div>
            <div className={styles.detailsContainer}>
              <h3 className={styles.title}>{item.title}</h3>
              <div className={styles.prices}>
                <p className={styles.regularPrice}>標準価格: ¥{item.regular_price}</p>
                <p className={styles.salePrice}>セール価格: ¥{item.sale_price}</p>
              </div>
              <div className={styles.rating}>
              {item.review_count > 0 && (
                <>
                  <StarRating score={item.rating} />
                  <p>({item.review_count})</p>
                </>
              )}
              </div>
              <div className={styles.tags}>
                {item.tags.map((tag, tagIndex) => (
                  <span key={tagIndex} className={styles.tag}>{tag.name}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default RelatedTours;
